module.exports = __webpack_public_path__ + "463f12988971770f7e996982bc5dfdb8.svg";